import { IPatientInfo } from 'apis/admin/type';
import { SurveyFormProps } from 'components/MuiDialog/SurveyForm';
import {
  initialECardex,
  initialTakingOver,
  initialOutHospitalSurvey,
  initialHospitalizationSurvey,
  initialMedicationSurvey,
  initialRadiology,
  initialPathology,
  initialBedScore,
  initialBedScoreTwo,
  initialFall,
  initialFallTwo,
  initialPediatric_fall,
  initialGCS,
  initialPediatric_GCS,
  initialNeeds,
  initialClinicalObservation,
  initialGlucose,
  initialSafety,
  initialNRS,
  initialFLACC,
  initialCNPS,
  initialMentalNursing,
  initialBDI,
  initialBAI,
  initialMMSE,
  initialCIST,
  initialOperation,
  initialAnesthesia,
  initialTransfusion,
  initialDialysis,
  initialEmergency,
  initialChildbirth,
  initialHomeCare,
  initialHospitalConfirm,
  initialFallConfirm,
  initialColonoscopy,
  initialUpperEndoscopy,
  initialNonSalary,
  initialMedicalRecords,
  initialSuppressor,
  initialDNR,
  initialDNA,
  initialCoreNursingSkillVideo,
  initialCoreNursingSkillVideoExemple,
  initialFourScore,
  initialCheckListRoom,
  initialFFI,
  initialKOOS,
  initialLEFS,
  initialSTarTBack,
  initialNDI,
  initialDietList,
  initialKPCS,
  initialTransfusionAgree,
  initialCRRT,
  initialIntubation,
  initialCPR,
  initialNursingProcess,
  initialKPCS_ICU,
  initialCentralVenous,
  initialDNRTwo,
  initialKPCSC_NICU,
  initialKPCS_GW,
  initialKPCSN,
  initialKPCSC,
  initialKDSQ_P,
  initialKDSQ_C,
  initialK_CPAT,
  initialPAINAD_K,
  initialPAINAD_K_none,
  initialClinicalObservationICU,
  initialIntakeOutput,
  initialIntubationAgree,
  initialFallThree,
  initialMSE,
  initialNEWS2,
  initialBloodDispensing,
  initialBedScoreFour,
  initialBedScoreThree,
  initialSBAR,
  initialSBAR2,
  initialSBAR3,
  initialNursingNeed,
  initialAdmissionAndDischarge,
  initialSelfDischarge,
  initialInfection,
  initialEtcRecord,
  initialRestraint,
  initialSimulationPlan,
  initialProcessRecord,
  initialPersonalInfoAgreement,
  initialDebriefing,
  initialMinor,
  initialECMO,
  initialSubmitAssignment,
  initialConsentForSurgery,
  initialMaturity,
} from './initialStates';

export enum MENU {
  E_CARDEX = 'e-CARDEX',
  TAKING_OVER = '간호 인수인계',
  SBAR = 'SBAR',
  SBAR2 = 'SBAR2',
  SBAR3 = 'SBAR3',
  HOSPITALIZATION = '입원간호 기록지',
  OUT_HOSPITAL = '퇴원간호 기록지',
  PRESCRIPTION = '환자상황 및 처방내역',
  NURSE = '간호 기록지',
  MEDICATION = '투약 기록지',
  RADIOLOGY = '영상검사 기록지',
  PATHOLOGY = '임상병리검사\n기록지',
  CLINICAL_OBSERVATION = '활력징후 기록지',
  CLINICAL_OBSERVATION_ICU = '임상관찰 기록지(ICU)',
  NEWS2 = 'NEWS 2',
  IORECORD = '섭취 및 배설량\n기록지',
  GLUCOSE = '혈당 기록지',
  BEDSORES = '욕창위험\n평가도구 1',
  BEDSORESTWO = '욕창위험\n평가도구 2',
  BEDSORESTHREE = '욕창위험\n평가도구 3',
  BEDSORESFOUR = '욕창위험\n평가도구 4',
  NEEDS = '욕구평가 기록지',
  FALL = '낙상위험\n평가도구 1',
  FALLTWO = '낙상위험\n평가도구 2',
  FALLTHREE = '낙상위험\n평가도구 3',
  FALLSCALE = '소아 낙상위험\n평가',
  GCS = 'GCS',
  Pediatric_GCS = 'Pediatric GCS',
  FourScore = 'FOUR Score',
  Maturity = '고위험 신생아의\n성숙도 사정',
  PAIN = '통증평가도구',
  SAFETY = '환자안전사고\n보고서',
  INFECTION = '감염노출 보고서',
  NRS = 'NRS',
  FFI = 'FFI',
  KOOS = 'KOOS',
  LEFS = 'LEFS',
  NDI = 'NDI',
  STarT_BacknScreening = 'STarT Back\nScreening',
  K_CPAT = 'K-CPAT',
  PAINAD_K = 'PAINAD-K\ncommunicative',
  PAINAD_K_non = 'PAINAD-K\nnoncommunicative',
  FLACC = 'FLACC Scale',
  CNPS = 'CNPS',
  RADIOLOGYETC = '기타 기록지',
  MENTAL_NURSING = '정신간호 기록지',
  MSE = 'MSE',
  BDI = 'BDI',
  BAI = 'BAI',
  MMSE = 'MMSE-K',
  CIST = 'CIST',
  KDSQ_P = 'KDSQ-P',
  KDSQ_C = 'KDSQ-C',
  COGNITIVE_FUNCTION = '인지기능검사',
  OPERATION = '수술 기록지',
  ANESTHESIA = '마취 기록지',
  TRANSFUSION = '수혈 기록지',
  BLOODDISCHARGE = '혈액불출요청서',
  RESTRAINT = '신체보호대 기록지',
  CPR = 'CPR 기록지',
  DIALYSIS = '투석 기록지',
  EMERGENCY = '응급 기록지',
  INTUBATION = '삽관 기록지',
  CHILDBIRTH = '분만 기록지',
  HOME_CARE = '가정간호 기록지',
  ECMO = 'ECMO 기록지',
  KPCS = 'KPCS',
  KPCSC = 'KPCSC',
  KPCSN = 'KPCSN',
  KPCS_GW = 'KPCS-GW',
  KPCS_ICU = 'KPCS-ICU',
  KPCS_NICU = 'KPCS-NICU',
  NURSING_NEED = '간호필요도',
  DIET_NUTRITION = '식이/영양\n기록지',
  AGREEMENT = '동의서',
  HOSPITAL_CONFIRM = '입원 안내 확인서',
  ADMISSIN_AND_DISCHARGE = '입·퇴원 동의서',
  SELF_DISCHARGE = '자의퇴원서',
  FALL_CONFIRM = '낙상 예방교육\n확인서',
  TRANSFUSIONAGREEMENT = '수혈 동의서',
  CRRT_AGREEMENT = 'CRRT 동의서',
  CENTRALVENOUS = '중심정맥삽관\n동의서',
  INTUBATIONAGREEMENT = '기관내 삽관\n동의서',
  COLONOSCOPY = '대장내시경\n동의서',
  UPPER_ENDOSCOPY = '상부내시경\n동의서',
  SUPPRESSOR = '신체보호대\n동의서',
  NONSALARY = '비급여진료비\n동의서',
  CONSENT_FOR_SURGERY = '수술동의서',
  MEDICALRECORDS = '진료기록 열람, \n사본발급 동의서',
  DNR = '사전연명의료\n의향서',
  DNRTWO = '연명의료중단등결정\n환자가족 의사\n확인서',
  DNA = '유전자검사\n동의서',
  SUBMIT_ASSIGNMENT = '과제 제출',
  MINOR = '미성년자\n시술동의서',
  CORE_NURSING_SKILL_VIDEO = '핵심간호술기영상 저장',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE_ONE = '예시1 (수문사)',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE_TWO = '예시2 (현문사)',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE_THREE = '예시3 (알엔지야)',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE_FOUR = '예시4 (대한나래)',
  DRUG_CALCULATOR = '약물계산기',
  NURSING_PROCESS = '간호과정기록지2',
  NURSE_CHECKLIST_ROOM = '병동',
  VOICE_EMR = 'Voice EMR',
  SIMUL_ACTIVITY_PLAN = '활동계획서',
  SIMUL_PROCESS_RECORD = '간호과정 기록지',
  SIMUL_PERSONAL_INFO_AGREEMENT = '개인정보 수집\n동의서',
  DEBRIEFING = '디브리핑 기록지',
  PATIENT_LABEL_PRINTING = '환자 라벨 인쇄',
}

export enum RECORD_TYPE {
  NANDA = '0',
  SOAPIE = '1',
  FOCUS_DAR = '2',
  NARRATIVE_RECORD = '3',
  REMARKS = '4',
  REMARKSTWO = '5',
  OMAHA = '6',
  ICNP = '7',
  ICNPBROWSER = '8',
}

export interface SurveyDialogProps<T>
  extends Omit<SurveyFormProps, 'children'> {
  user_id: number;
  nurseName: string;
  patientInfo: IPatientInfo;
  disabled?: boolean;
  defaultValues: T;
}

export type TECardexDefaultValues = typeof initialECardex;
export type TTakingOverDefaultValues = typeof initialTakingOver;
export type TSBARDefaultValues = typeof initialSBAR;
export type TSBAR2DefaultValues = typeof initialSBAR2;
export type TSBAR3DefaultValues = typeof initialSBAR3;
export type THospitalizationDefaultValues = typeof initialHospitalizationSurvey;
export type TOutHospitalDefaultValues = typeof initialOutHospitalSurvey;
export type TMedicationDefaultValues = typeof initialMedicationSurvey;
export type TRadiologyDefaultValues = typeof initialRadiology;
export type TPathologyDefaultValues = typeof initialPathology;
export type TClinicalObservationDefaultValues =
  typeof initialClinicalObservation;
export type TClinicalObservationICUDefaultValues =
  typeof initialClinicalObservationICU;
export type TGlucoseDefaultValues = typeof initialGlucose;
export type TIntakeOutputDefaultValues = typeof initialIntakeOutput;
export type TNEWS2DefaultValues = typeof initialNEWS2;
export type TBedScoreDefaultValues = typeof initialBedScore;
export type TBedScoreTwoDefaultValues = typeof initialBedScoreTwo;
export type TBedScoreThreeDefaultValues = typeof initialBedScoreThree;
export type TBedScoreFourDefaultValues = typeof initialBedScoreFour;
export type TNeedsDefaultValues = typeof initialNeeds;
export type TFallDefaultValues = typeof initialFall;
export type TFallTwoDefaultValues = typeof initialFallTwo;
export type TFallThreeDefaultValues = typeof initialFallThree;
export type TGCSDefaultValues = typeof initialGCS;
export type TPediaTric_GCSDefaultValues = typeof initialPediatric_GCS;
export type TFourScoreDefaultValues = typeof initialFourScore;
export type TMaturityDefaultValues = typeof initialMaturity;
export type TPediatric_fallDefaultValues = typeof initialPediatric_fall;
export type TSafetyDefaultValues = typeof initialSafety;
export type TInfectionDefaultValues = typeof initialInfection;
export type TNRSDefaultValues = typeof initialNRS;
export type TFLACCDefaultValues = typeof initialFLACC;
export type TCNPSDefaultValues = typeof initialCNPS;
export type TFFIDefaultValues = typeof initialFFI;
export type TKOOSDefaultValues = typeof initialKOOS;
export type TLEFSDefaultValues = typeof initialLEFS;
export type TNDIDefaultValues = typeof initialNDI;
export type TSTarTBackScreeningDefaultValues = typeof initialSTarTBack;
export type TK_CPATDefaultValues = typeof initialK_CPAT;
export type TPAINAD_KDefaultValues = typeof initialPAINAD_K;
export type TPAINAD_K_noneDefaultValues = typeof initialPAINAD_K_none;
export type TMentalNursingDefaultValues = typeof initialMentalNursing;
export type TMSEDefaultValues = typeof initialMSE;
export type TBDIDefaultValues = typeof initialBDI;
export type TBAIDefaultValues = typeof initialBAI;
export type TMMSEDefaultValues = typeof initialMMSE;
export type TCISTDefaultValues = typeof initialCIST;
export type TKDSQ_PDefaultValues = typeof initialKDSQ_P;
export type TKDSQ_CDefaultValues = typeof initialKDSQ_C;
export type TOperationDefaultValues = typeof initialOperation;
export type TAnesthesiaDefaultValues = typeof initialAnesthesia;
export type TBloodDispensingDefaultValues = typeof initialBloodDispensing;
export type TTransfusionDefaultValues = typeof initialTransfusion;
export type TRestraintDefaultValues = typeof initialRestraint;
export type TCPRDefaultValues = typeof initialCPR;
export type TDialysisDefaultValues = typeof initialDialysis;
export type TEmergencyDefaultValues = typeof initialEmergency;
export type TIntubationDefaultValues = typeof initialIntubation;
export type TChildbirthDefaultValues = typeof initialChildbirth;
export type THomeCareDefaultValues = typeof initialHomeCare;
export type TECMOCareDefaultValues = typeof initialECMO;
export type TKPCSDefaultValues = typeof initialKPCS;
export type TKPCSCDefaultValues = typeof initialKPCSC;
export type TKPCSNDefaultValues = typeof initialKPCSN;
export type TKPCS_GWDefaultValues = typeof initialKPCS_GW;
export type TKPCS_ICUDefaultValues = typeof initialKPCS_ICU;
export type TKPCS_NICUDefaultValues = typeof initialKPCSC_NICU;
export type TEtcRecordDefaultValues = typeof initialEtcRecord;
export type TNursing_NeedDefaultValues = typeof initialNursingNeed;
export type TDietListDefaultValues = typeof initialDietList;
export type THospitalConfirmDefaultValues = typeof initialHospitalConfirm;
export type TAdmAndDischargeDefaultValues = typeof initialAdmissionAndDischarge;
export type TSelfDischargeDefaultValues = typeof initialSelfDischarge;
export type TFallConfirmDefaultValues = typeof initialFallConfirm;
export type TTransfusionAgreeDefaultValues = typeof initialTransfusionAgree;
export type TIntubationAgreeDefaultValues = typeof initialIntubationAgree;
export type TCRRTDefaultValues = typeof initialCRRT;
export type TColonoscopyDefaultValues = typeof initialColonoscopy;
export type TUpperEndoscopyDefaultValues = typeof initialUpperEndoscopy;
export type TSuppressorDefaultValues = typeof initialSuppressor;
export type TNonSalaryDefaultValues = typeof initialNonSalary;
export type TConsentForSurgeryDefaultValues = typeof initialConsentForSurgery;
export type TMedicalRecordDefaultValues = typeof initialMedicalRecords;
export type TCentralVenousDefaultValues = typeof initialCentralVenous;

export type TDNRDefaultValues = typeof initialDNR;
export type TDNRTwoDefaultValues = typeof initialDNRTwo;
export type TDNADefaultValues = typeof initialDNA;
export type TMinorDefaultValues = typeof initialMinor;

export type TCheckListRoomDefaultValues = typeof initialCheckListRoom;

export type TCoreNursingSkillVideoDefaultValues =
  typeof initialCoreNursingSkillVideo;
export type TCoreNursingSkillVideoDeExemplefaultValues =
  typeof initialCoreNursingSkillVideoExemple;

export type TNursingProcessDefaultValues = typeof initialNursingProcess;

export type TSimulationPlan = typeof initialSimulationPlan;
export type TProcessRecord = typeof initialProcessRecord;
export type TPersonalInfoAgreement = typeof initialPersonalInfoAgreement;
export type TDebriefingDefaultValues = typeof initialDebriefing;

export type TSubmitAssignmentDefaultValues = typeof initialSubmitAssignment;
